import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { startWith, takeUntil } from 'rxjs/operators';
import { map } from 'rxjs/internal/operators/map';
import { Observable, Subject, Subscription } from 'rxjs';
import { SharedService } from 'src/app/shared/service/shared.service';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/service/data.service';

@Component({
  selector: 'app-select-line',
  templateUrl: './select-line.component.html',
  styleUrls: ['./select-line.component.scss']
})
export class SelectLineComponent implements OnInit, OnDestroy {
  clusterFilteredOptions: Observable<string[]>;
  factoryFilteredOptions: Observable<string[]>;
  lineFilteredOptions: Observable<string[]>;
  clustersList: any[] = [];
  factoriesList: any[] = [];
  linesList: any[] = [];
  lineSelectors: UntypedFormGroup;
  linesListToStore: any;
  lineUnderCluster;
  lineUnderFactory;
  lineUnderLine;
  localStorageName: any;

  getRealTimeLineListSub: Subscription;
  getDFOSFactoryListSub: Subscription;
  uniqueLineCluster: any[];
  selectedClusterFactory: any;
  selectedClusterforLine: any;

  public _filter(clusterValue: string): string[] {
    const filterValues = clusterValue.toLowerCase();
    return this.clustersList.filter(option => option && option.subRegionName && option.subRegionName.toLowerCase().includes(filterValues));
  }

  public _filterfact(factoryValue: string): string[] {
    const filterValues = factoryValue.toLowerCase();
    return this.factoriesList.filter(option => option && option.name && option.name.toLowerCase().includes(filterValues));
  }

  public _filterline(lineValue: string): string[] {
    const filterValues = lineValue.toLowerCase();
    return this.linesList.filter(option => option && option.name && option.name.toLowerCase().includes(filterValues));
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public dataPassed,
    public formBuilder: UntypedFormBuilder,
    private dialog: MatDialogRef<SelectLineComponent>,
    private sharedService: SharedService,
    private dataSer: DataService) {
    this.lineSelectors = this.formBuilder.group({
      cluster: ['', [Validators.required]],
      clusterid: ['', [Validators.required]],
      factory: ['', [Validators.required]],
      factoryid: ['', [Validators.required]],
      line: ['', [Validators.required]],
      lineid: ['', [Validators.required]],
    });

    if (this.dataPassed && this.dataPassed.localStorageName) {
      this.localStorageName = this.dataPassed.localStorageName;
    } else {
      this.localStorageName = [];
    }

    this.lineSelectors.controls.factory.disable();
    this.lineSelectors.controls.line.disable();
    this.getCluster();
  }

  ngOnInit() { }

  onClusterChanged(selectedCluster: any) {
    if (selectedCluster.id) {
      this.lineUnderCluster = selectedCluster;
      this.lineSelectors.controls.clusterid.setValue(selectedCluster.id);
      this.lineSelectors.controls.factory.enable();
      this.lineSelectors.controls.line.disable();
      this.getFactoryList(selectedCluster);
      this.lineSelectors.controls.factory.setValue('');
      this.lineSelectors.controls.line.setValue('');
    }
  }

  onFactoryChanged(selectedFactory: any) {
    if (selectedFactory.id) {
      this.lineUnderFactory = selectedFactory;
      this.lineSelectors.controls.factoryid.setValue(selectedFactory.id);
      this.lineSelectors.controls.line.setValue('');
      this.lineSelectors.controls.line.enable();
      this.getLineList(this.lineUnderCluster, this.lineUnderFactory);
    }
  }

  onLineChanged(selectedLine) {
    if (selectedLine.id) {
      this.lineUnderLine = selectedLine;
      this.lineSelectors.controls.lineid.setValue(selectedLine.id);
    }
  }

  /* istanbul ignore next */
  getCluster() {
    this.clustersList = [];
    // const clusterList = JSON.parse(localStorage.getItem('dfos.userfactory.data'));

    this.doAsyncTaskSelectLine().then((data: any[]) => {

      if (data) {
        this.clustersList = data;
      }
      this.clusterFilteredOptions = this.lineSelectors.controls.cluster.valueChanges.pipe(
        startWith(''),
        map(clusterValue => this._filter(clusterValue))
      );
      this.uniqueLineCluster = [];
      this.uniqueLineCluster = [...new Map(this.clustersList.map((m) => [m.subRegionName, m])).values()];
      this.uniqueLineCluster.sort((a, b) => a.subRegionName.localeCompare(b.subRegionName));

      if (JSON.parse(this.dataSer.getStorageData(this.localStorageName)) &&
        JSON.parse(this.dataSer.getStorageData(this.localStorageName)).cluster) {
        if (this.clustersList && this.clustersList.length > 0) {
          const data = JSON.parse(this.dataSer.getStorageData(this.localStorageName)).cluster.subRegionName;
          this.clustersList.forEach((clusters) => {
            if (clusters.subRegionName === data) {
              this.lineSelectors.controls.cluster.setValue(JSON.parse(this.dataSer.getStorageData(this.localStorageName)).cluster.subRegionName);
              this.onClusterChanged(JSON.parse(this.dataSer.getStorageData(this.localStorageName)).cluster);
            }
          });
        }
      }

    },
      (err) => {

      });


  }

  /* istanbul ignore next */
  get f() {
    return this.lineSelectors.controls;
  }
  /* istanbul ignore next */
  autoCompleteCluster(event: string) {
    this.f.factory.setValue('');
    this.f.factory.disable();
    if (event && event !== '') {
      const searchKeyword = event.toLowerCase();
      // const clonedClusterList = [...this.clusterList];
      this.uniqueLineCluster = [...new Map(this.clustersList.map((m) => [m.subRegionName, m])).values()];
      this.uniqueLineCluster = this.uniqueLineCluster.filter(c => {
        if (c.subRegionName.toLowerCase().includes(searchKeyword)) {
          return true;
        }
      });
      this.uniqueLineCluster.sort((a, b) => a.subRegionName.localeCompare(b.subRegionName));
    } else {
      this.uniqueLineCluster = [...new Map(this.clustersList.map((m) => [m.subRegionName, m])).values()];
      this.uniqueLineCluster.sort((a, b) => a.subRegionName.localeCompare(b.subRegionName));
      // this.factoryList = this.factoryList;
    }
  }
  /* istanbul ignore next */
  autoCompleteFactory(event: string) {
    if (event && event !== '') {
      const searchKeyword = event.toLowerCase();
      const clonedFactoryList = [...this.factoriesList];
      this.selectedClusterFactory = clonedFactoryList.filter(f => {
        if (f.name.toLowerCase().includes(searchKeyword)) {
          return true;
        }
      });
    } else {
      this.uniqueLineCluster = [...new Map(this.clustersList.map((m) => [m.subRegionName, m])).values()];
      this.uniqueLineCluster.sort((a, b) => a.subRegionName.localeCompare(b.subRegionName));
      this.selectedClusterFactory = this.factoriesList;
      this.selectedClusterFactory.sort((a, b) => a.subRegionName.localeCompare(b.subRegionName));
    }
  }

  doAsyncTaskSelectLine() {
    return new Promise((resolve, reject) => {
      this.sharedService.getRealTimeClusterList().subscribe((dataSelectLine => {
        if (dataSelectLine && dataSelectLine.length > 0) {
          resolve(dataSelectLine);
        } else {
          reject('error');
        }
      }));
    });
  }

  processFactoryResp(dataOrder, clstrId) {
    const factoryRespns = {
      status: 'success',
      data: []
    };
    if (dataOrder.length > 0) {
      for (const clusterOrder of dataOrder) {
        if (clusterOrder.id === clstrId) {
          if (clusterOrder.factoryList) {
            for (const factoryOrder of clusterOrder.factoryList) {
              const tempFactoryLst = {
                name: factoryOrder.name,
                id: factoryOrder.id ? factoryOrder.id.$oid : '',
                language: factoryOrder.language,
                comments: factoryOrder.comments,
                isActive: factoryOrder.IsActive,
                localName: factoryOrder.localName,
                nodetype: factoryOrder.nodetype,
                sapPlantCode: factoryOrder.sapPlantCode,
                site: factoryOrder.site,
                timeZone: factoryOrder.timeZone,
                factoryId: factoryOrder.factoryId,
                latitude: (factoryOrder.latitude) ? factoryOrder.latitude : '',
                longitude: (factoryOrder.longitude) ? factoryOrder.longitude : ''
              };
              factoryRespns.data.push(tempFactoryLst);
            }
          }
        }
      }
      return factoryRespns.data;
    } else {
      return factoryRespns.data;
    }
  }
  /* istanbul ignore next */
  getFactoryList(selectedClusterOdr: any) {
    this.factoriesList = [];
    this.selectedClusterFactory = [];
    if (this.clustersList && this.clustersList.length > 0) {
      /* this.factoriesList = this.processFactoryResp(this.clustersList, selectedClusterOdr.id ?
        selectedClusterOdr.id : selectedClusterOdr.cluster.id);
      this.factoryFilteredOptions = this.lineSelectors.controls.factory.valueChanges
        .pipe(
          startWith(''),
          map(factoryValueData => this._filterfact(factoryValueData))
        ); */
      for (let index = 0; index < this.clustersList.length; index++) {
        if (this.clustersList[index].subRegionName === selectedClusterOdr.subRegionName) {
          this.clustersList.forEach((entry) => {
            entry.factoryList.forEach(element => {
              element['subRegionName'] = entry.subRegionName;
              element['selectedCLusterId'] = entry.clusterId;
            });
           // console.log("line Summary", entry);
          });
          this.selectedClusterFactory = this.factoriesList = [...this.selectedClusterFactory, ...this.clustersList[index].factoryList];
        }
        this.selectedClusterFactory.sort((a, b) => a.name.localeCompare(b.name));
      }

      /* istanbul ignore if */
      if (JSON.parse(this.dataSer.getStorageData(this.localStorageName)) &&
        JSON.parse(this.dataSer.getStorageData(this.localStorageName)).factory) {
        if (this.factoriesList && this.factoriesList.length > 0) {
          this.factoriesList.forEach((factoryLi) => {
            if (factoryLi.name === JSON.parse(this.dataSer.getStorageData(this.localStorageName)).factory.name) {
              this.lineSelectors.controls.factory.setValue(JSON.parse(this.dataSer.getStorageData(this.localStorageName)).factory.name);
              this.onFactoryChanged(JSON.parse(this.dataSer.getStorageData(this.localStorageName)).factory);
            }
          });
        }
      }
    } else {
      this.getDFOSFactoryListSub = this.sharedService.getDFOSFactoryList(selectedClusterOdr)
        .subscribe(result => {
          this.factoriesList = result;
          this.factoryFilteredOptions = this.lineSelectors.controls.factory.valueChanges
            .pipe(
              startWith(''),
              map(factoryValueInOrder => this._filterfact(factoryValueInOrder))
            );

          if (JSON.parse(this.dataSer.getStorageData(this.localStorageName)) &&
            JSON.parse(this.dataSer.getStorageData(this.localStorageName)).factory) {
            if (this.factoriesList && this.factoriesList.length > 0) {
              this.factoriesList.forEach((factoriesDt) => {
                if (factoriesDt.name === JSON.parse(this.dataSer.getStorageData(this.localStorageName)).factory.name) {
                  this.lineSelectors.controls.factory.setValue(JSON.parse(this.dataSer.getStorageData(this.localStorageName)).factory.name);
                  this.onFactoryChanged(JSON.parse(this.dataSer.getStorageData(this.localStorageName)).factory);
                }
              });
            }
          }
        });
    }
  }
  /* istanbul ignore next */
  getLineList(selectedCluster: any, selectedFactory: any) {
    this.linesListToStore = [];
    this.linesList = [];
    // this.sharedService.getDFOSLineList({ cluster: selectedCluster, factory: selectedFactory }).subscribe(result => {
    // this.sharedService.getRealTimeLineList({ cluster: selectedCluster, factory: selectedFactory })
    //   // .pipe(takeUntil(this.destroy$))
    //   .subscribe(result => {

    // test code for mapping to correct cluster
    // if (!selectedFactory.factoryId.includes(selectedCluster.factoryList)) {
    //   if (!selectedCluster.factoryList.includes(selectedFactory.factoryId)) {
    this.selectedClusterforLine = this.clustersList.find(x => x.clusterId === selectedFactory.selectedCLusterId && x.subRegionName === selectedFactory.subRegionName);
    console.log('selectedClusterforLine', this.selectedClusterforLine);
    this.lineUnderCluster = this.selectedClusterforLine;
    if (this.selectedClusterforLine && this.selectedClusterforLine.factoryList && this.selectedClusterforLine.factoryList.length > 0) {
      this.linesList = this.selectedClusterforLine.factoryList.find(fact => fact.factoryId === selectedFactory.factoryId).lineList;
    } else {
      this.lineUnderCluster = selectedCluster;
      if (selectedCluster && selectedCluster.factoryList && selectedCluster.factoryList.length > 0) {
        this.linesList = selectedCluster.factoryList.find(fact => fact.factoryId === selectedFactory.factoryId).lineList;
      }
    }
    // end
    const lineListDataArr = [];
    this.linesList.forEach((item) => {
      const obj = {
        name: item.name,
        Name: item.name,
        id: item.lineId,
        Id: item.lineId,
        lineId: item.name
      };
      lineListDataArr.push(obj);
    });
    this.linesList = lineListDataArr;

    this.linesListToStore = this.linesList;

    this.lineFilteredOptions = this.lineSelectors.controls.line.valueChanges
      .pipe(
        startWith(''),
        map(lineValue => this._filterline(lineValue))
      );

    if (JSON.parse(this.dataSer.getStorageData(this.localStorageName)) &&
      JSON.parse(this.dataSer.getStorageData(this.localStorageName)).line) {
      if (this.linesList && this.linesList.length > 0) {
        this.linesList.forEach((line) => {
          if (line.name === JSON.parse(this.dataSer.getStorageData(this.localStorageName)).line.name) {
            this.lineSelectors.controls.line.setValue(JSON.parse(this.dataSer.getStorageData(this.localStorageName)).line.name);
            this.onLineChanged(JSON.parse(this.dataSer.getStorageData(this.localStorageName)).line);
          }
        });
      }
    }
    //   }
    // });
  }

  valueReset(catg: any) {
    if (catg === 'cluster') {
      this.lineSelectors.controls.clusterid.reset();
      this.lineSelectors.controls.factory.disable();
      this.lineSelectors.controls.line.disable();
    } else if (catg === 'factory') {
      this.lineSelectors.controls.factoryid.reset();
      this.lineSelectors.controls.line.disable();
    } else if (catg === 'line') {
      this.lineSelectors.controls.lineid.reset();
    }
  }

  dialogClose() {
    this.dialog.close({ action: 'cancelled' });
  }

  onSubmit() {
    this.dialog.close(
      {
        action: 'submitted',
        selectedValues: {
          cluster: this.lineUnderCluster,
          factory: this.lineUnderFactory,
          line: this.lineUnderLine,
          lineList: this.linesListToStore
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.getRealTimeLineListSub) {
      this.getRealTimeLineListSub.unsubscribe();
    }
    if (this.getDFOSFactoryListSub) {
      this.getDFOSFactoryListSub.unsubscribe();
    }
  }
}
